import { useContext } from "react";
import ScrollFilterBar from "../Common/Filter/ScrollFilterBar";
import SchoolContext from "../../Context/SchoolContext";
import FilterSelectInput from "../Common/Filter/FilterSelectInput";
import FilterTextInput from "../Common/Filter/FilterTextInput";

const StudentFilter = ()=>{

    const { classListing,  residenceListing} = useContext(SchoolContext);
    const { resetData,  filterStudent} = useContext(SchoolContext)


        const optionsclassList=[{title:"All Classes", value:"0"}];
        if(Array.isArray(classListing))
        {
            classListing.forEach((item)=>
                optionsclassList.push({title:item.class_name, value:item.reference_id})
            )
        }
    
        const optionsResidence=[{title:"All Residences", value:"0"}]
        if(Array.isArray(residenceListing)){
          residenceListing.forEach(item =>{
            optionsResidence.push({title:item.residence_name, value:item.reference_id})
          })
        }

        const optionsBillingType = [
          {title: "All...", value:""},
          {title: "Billed", value:"1"},
          {title: "Unblilled", value:"2"}
      ];
    
        return (
            <ScrollFilterBar
                onReset={resetData}
                onConfirm={filterStudent}
                firstScreen={
                  {
                    inputs:[
                        (onSet, key)=><FilterSelectInput
                          key={key}
                          label="Filter By Class"
                          options={optionsclassList}
                          onChange={onSet}
                          name="studentClass"
                        />,
                        (onSet, key)=><FilterSelectInput
                        key={key}
                        label="Filter By Residence"
                        options={optionsResidence}
                        onChange={onSet}
                        name="studentResidence"
                      />,
                      (onSet, key)=><FilterSelectInput
                      key={key}
                      label="Billing Status"
                      options={optionsBillingType}
                      onChange={onSet}
                      name="billingStatus"
                    />,
                    (onSet, key)=> <FilterTextInput 
                    key={key}
                    label="Student Reg No."
                    placeholder="Eg. STK...." 
                    onChange={onSet}
                    name="studentReg"
                    type="text"
                    />,
                    ],
                    names:["studentClass", "studentResidence", "billingStatus", "studentReg"]
                  }
                }
            />
        )
    

}

export default StudentFilter;